import { log_debug, log_info } from "../utils/log";
import {
  CHECK_PHNO,
  CHECK_BUSINESS_NAME,
  COUNTRY_STATES,
  CREATE_AGENT,
  CREATE_PROFILE,
  CREATE_USER,
  DELETE_CLIENT_PHOTO,
  DISTRICT_CITIES,
  EDIT_PROFILE,
  FORWARD_TO_CLIENT,
  GET_ALL_AGENTS,
  GET_CASTES,
  GET_CLIENT_PREFERENCE,
  GET_COMMUNITITES,
  GET_EVENTS,
  GET_HABITS,
  GET_HOBBIES,
  GET_LANGUAGE,
  GET_MARITAL_STATUS,
  GET_PHYSHICAL_BUILD,
  GET_PROFILEBY_CLIENTCODE,
  GET_PROFILEBYID,
  GET_PROFILES,
  GET_QUALIFICATION,
  GET_RELATIONS,
  GET_RELIGIONS,
  GET_SKIN_TONE,
  GET_USERBYID,
  LOG_IN,
  MATCHES_FOR_CLIENT,
  STATE_DISTRICTS,
  UPDATE_CLIENT_PHOTO,
  UPDATE_CLIENT_PREFERENCE,
  UPDATE_CLIENT_VIDEO,
  UPDATE_MATCH,
  UPDATE_USER_PHOTO,
  EDIT_AGENT,
  GET_CLIENT_RELATIONS,
  CREATE_CLIENT,
  GET_PROFILES_BY_CLIENT,
  CREATE_MATCHES_BY_PREFERENCE,
  GET_LEVEL1_CASTE,
  GET_LEVEL2_CASTE,
  GET_LEVEL3_CASTE,
  GET_COUNTRIES,
  DELETE_PROFILE,
  ACTIVE_PROFILE,
  GET_AGENT,
  GET_CLIENT,
  EDIT_CLIENT,
  SEND_REQUEST,
  GET_REQUEST_STATUS,
  CHECK_REQUEST_STATUS,
  GET_ALL_COUNTRIES,
  GET_STATES,
  GET_CITIES,
  GET_NOTIFICATIONS,
  GET_CASTE_NAME,
  GET_ALL_CASTE,
  UPDATE_CLIENT_DOC,
  LOG_IN_BYGOOGLE,
  WEDLUK_COMMUNITY_DOCS,
  DELETE_FAMILY_WEALTH,
  CHECK_EMAIL,
  LOG_IN_BYEMAIL,
  SEND_SIGNUP_OTP,
  VERIFY_OTP,
  REGISTER_USER,
  SET_MAIN_PROFILE_PHOTO,
  FORGOT_PASSWORD,
  GET_PROFILE_ACTIVATION_BY_CODE,
  UPDATE_PROMOTIONAL_IMAGES,
  UPDATE_BUSINESS_LOGO,
  CREATE_AGENT_REVIEW,
  GET_AGENT_REVIEW,
  GET_AGENT_REVIEW_BY_PROFILE,
  DISABLE_USER_ACCOUNT,
  DELETE_USER_ACCOUNT,
  REPORT_ISSUES,
  ENABLE_USER_ACCOUNT,
  GET_NOTIFICATIONS_PROFILES,
  DELETE_PROMOTIONAL_IMAGES,
  GOOGLE_LOGIN_API,
  RESET_PASSWORD,
  DELETE_CLIENT_VIDEO,
} from "./app_url";
import {
  doGetRequest,
  doPostRequest,
  doPostRequestImageFile,
  doPutRequest,
} from "./fetchcalls";

export const get_religios = async (data) => {
  let response = await doGetRequest(GET_RELIGIONS, data);
  return response;
};
export const get_castes = async (data) => {
  let response = await doGetRequest(GET_CASTES, data);
  return response;
};
export const get_communities = async (data) => {
  let response = await doGetRequest(GET_COMMUNITITES, data);
  return response;
};
export const get_marital_status = async (data) => {
  let response = await doGetRequest(GET_MARITAL_STATUS, data);
  return response;
};
export const get_skin_tone = async (data) => {
  let response = await doGetRequest(GET_SKIN_TONE, data);
  return response;
};
export const get_physical_build = async (data) => {
  let response = await doGetRequest(GET_PHYSHICAL_BUILD, data);
  return response;
};
export const get_habits = async (data) => {
  let response = await doGetRequest(GET_HABITS, data);
  return response;
};
export const get_hobbies = async (data) => {
  let response = await doGetRequest(GET_HOBBIES, data);
  return response;
};
export const get_relations = async (data) => {
  let response = await doGetRequest(GET_RELATIONS, data);
  return response;
};
export const get_qualification = async () => {
  let response = await doGetRequest(GET_QUALIFICATION);
  return response;
};
export const get_profiles_by_agents = async (AgentId) => {
  console.log(GET_PROFILES + "?AgentId=" + AgentId);
  let response = await doGetRequest(GET_PROFILES + "?AgentId=" + AgentId);
  return response;
};
export const get_profiles_by_client = async (ClientId) => {
  console.log(GET_PROFILES_BY_CLIENT + "?ClientId=" + ClientId);
  let response = await doGetRequest(
    GET_PROFILES_BY_CLIENT + "?ClientId=" + ClientId,
  );
  return response;
};
export const get_user_byid = async (userId) => {
  let response = await doGetRequest(GET_USERBYID + "?userId=" + userId);
  return response;
};
export const get_client = async (userId) => {
  let response = await doGetRequest(GET_CLIENT + "?UserId=" + userId);
  return response;
};
export const get_profile_byid = async (profileId) => {
  console.log(GET_PROFILEBYID + "?ProfileId=" + profileId);
  let response = await doGetRequest(
    GET_PROFILEBYID + "?ProfileId=" + profileId,
  );
  return response;
};
export const get_profile_by_client_code = async (ClientCode) => {
  let response = await doGetRequest(
    GET_PROFILEBY_CLIENTCODE + "?ClientCode=" + ClientCode,
  );
  return response;
};
export const validate_profile_activation = async (ClientCode, PhoneNumber,CountyCode) => {
  let response = await doGetRequest(
    GET_PROFILE_ACTIVATION_BY_CODE +
      "?ClientCode=" +
      ClientCode +
      "&PhoneNumber=" +
      PhoneNumber+
      "&CountyCode="+ 
      CountyCode,
  );
  return response;
};
export const get_matches_for_client = async (profileId) => {
  let response = await doGetRequest(
    MATCHES_FOR_CLIENT + "?ProfileId=" + profileId,
  );
  console.log("link", MATCHES_FOR_CLIENT + "?ProfileId=" + profileId);
  return response;
};

export const create_user = async (data) => {
  let response = await doPostRequest(CREATE_USER, data);
  return response;
};
export const register_user_by_email = async (data) => {
  let response = await doPostRequest(REGISTER_USER, data);
  return response;
};

export const log_in = async (data) => {
  let response = await doPostRequest(LOG_IN, data);
  return response;
};
export const log_in_by_google = async (data) => {
  let response = await doPostRequest(LOG_IN_BYGOOGLE, data);
  return response;
};

export const log_in_by_email = async (data) => {
  let response = await doPostRequest(LOG_IN_BYEMAIL, data);
  return response;
};
export const send_signup_otp = async (data) => {
  let response = await doPostRequest(SEND_SIGNUP_OTP, data);
  return response;
};
export const verify_otp = async (data) => {
  let response = await doPostRequest(VERIFY_OTP, data);
  return response;
};
export const forgot_Password = async (data) => {
  let response = await doPostRequest(FORGOT_PASSWORD, data);
  return response;
};
export const create_agent = async (data) => {
  let response = await doPostRequest(CREATE_AGENT, data);
  return response;
};
export const update_agent = async (data) => {
  let response = await doPostRequest(EDIT_AGENT, data);
  return response;
};
export const edit_agent = async (data) => {
  let response = await doPostRequest(EDIT_AGENT, data);
  return response;
};
export const check_bussiness_name = async (data) => {
  let response = await doPostRequest(CHECK_BUSINESS_NAME, data);
  return response;
};
export const create_client = async (data) => {
  let response = await doPostRequest(CREATE_CLIENT, data);
  return response;
};
export const edit_client = async (data) => {
  let response = await doPostRequest(EDIT_CLIENT, data);
  return response;
};
export const create_profile = async (data) => {
  let response = await doPostRequest(CREATE_PROFILE, data);
  return response;
};
export const edit_profile = async (data) => {
  let response = await doPostRequest(EDIT_PROFILE, data);
  return response;
};
export const delete_profile = async (data) => {
  let response = await doPostRequest(DELETE_PROFILE, data);
  return response;
};

export const update_profile_active = async (data) => {
  let response = await doPostRequest(ACTIVE_PROFILE, data);
  return response;
};

export const get_country_states = async () => {
  let response = await doGetRequest(COUNTRY_STATES);
  return response;
};
export const get_language = async () => {
  let response = await doGetRequest(GET_LANGUAGE);
  return response;
};

export const get_country_list = async () => {
  let response = await doGetRequest(GET_COUNTRIES);
  return response;
};
export const get_state_districts = async (stateId) => {
  let response = await doGetRequest(STATE_DISTRICTS + "?stateId=" + stateId);
  return response;
};
export const get_district_cities = async (stateId, districtId) => {
  let response = await doGetRequest(
    DISTRICT_CITIES + "?stateId=" + stateId + "&districtId=" + districtId,
  );
  return response;
};

export const get_level1_caste = async (ReligionId) => {
  let url = GET_LEVEL1_CASTE;

  if (ReligionId) {
    url += `?ReligionId=${ReligionId}`;
  }

  const response = await doGetRequest(url);
  return response;
};

export const get_level2_caste = async (ReligionId, CasteL1Id) => {
  if (!ReligionId) {
    throw new Error("ReligionId is required");
  }

  let url = `${GET_LEVEL2_CASTE}?ReligionId=${ReligionId}`;

  if (CasteL1Id) {
    url += `&CasteL1Id=${CasteL1Id}`;
  }

  console.log("get_level2_caste url", url);

  const response = await doGetRequest(url);
  return response;
};

export const get_level3_caste = async (CasteL1Id, CasteL2Id) => {
  let url = GET_LEVEL3_CASTE;
  if (!CasteL2Id) {
    throw new Error("Caste are required");
  }

  url += `?CasteL2Id=${CasteL2Id}`;

  if (CasteL1Id) {
    url += `&CasteL1Id=${CasteL1Id}`;
  }

  let response = await doGetRequest(url);
  return response;
};

export const get_caste_name = async (CasteL2Id) => {
  let url = GET_CASTE_NAME;

  url += `?CasteL2Id=${CasteL2Id}`;
  // console.log("GET_CASTE_NAME", url);

  let response = await doGetRequest(url);
  return response;
};

export const get_all_castes = async () => {
  let url = GET_ALL_CASTE;
  let response = await doGetRequest(url);
  return response;
};

export const get_events = async () => {
  let response = await doGetRequest(GET_EVENTS);
  return response;
};
export const get_client_relations = async () => {
  let response = await doGetRequest(GET_CLIENT_RELATIONS);
  return response;
};
export const update_match_status = async (data) => {
  let response = await doPostRequest(UPDATE_MATCH, data);
  return response;
};
export const update_client_preferenca = async (data) => {
  let response = await doPostRequest(UPDATE_CLIENT_PREFERENCE, data);
  return response;
};
export const get_client_preferenca = async (ClientId) => {
  let response = await doGetRequest(
    GET_CLIENT_PREFERENCE + "?ClientId=" + ClientId,
  );
  return response;
};
export const check_phone_no = async (PhoneNumber) => {
  let response = await doPostRequest(
    CHECK_PHNO + "?PhoneNumber=" + PhoneNumber,
  );
  return response;
};
export const check_email = async (EMail) => {
  let response = await doPostRequest(CHECK_EMAIL + "?EMail=" + EMail);
  return response;
};

// export const update_profile_photo = async (userId, selectedFile) => {
//   const url = UPDATE_USER_PHOTO + "?UserId=" + userId;
//   const formData = await createFormData("avatar", selectedFile);
//   log_debug("formData: " + JSON.stringify(formData));
//   let response = await doPostRequestImageFile(url, formData);
//   log_info("Upload response: " + JSON.stringify(response));
//   return response;
// };

export const update_profile_photo = async (userId, selectedFile) => {
  // Extract extension
  const extension = selectedFile.name.substring(
    selectedFile.name.lastIndexOf("."),
  );

  // Sanitize filename: remove spaces, Unicode & special characters
  let cleanName = selectedFile.name
    .split(".")[0] // remove extension part
    .replace(/[^a-zA-Z0-9_-]/g, "") // keep only A-Z a-z 0-9 _ -
    .trim();

  if (!cleanName) cleanName = "avatar"; // fallback if all removed

  const newFileName = `${cleanName}${extension}`;

  const renamedFile = new File([selectedFile], newFileName, {
    type: selectedFile.type,
  });

  // Create FormData
  const formData = new FormData();
  formData.append("avatar", renamedFile);

  const url = UPDATE_USER_PHOTO + "?UserId=" + userId;

  log_debug("Uploading file name: " + newFileName);

  const response = await doPostRequestImageFile(url, formData);

  log_info("Upload response: " + JSON.stringify(response));
  return response;
};

export const update_profile_video = async (userId, selectedFile) => {
  const url = UPDATE_CLIENT_VIDEO + "?UserId=" + userId;
  const formData = await createFormDataforVideo("video", selectedFile);
  log_debug("formData: " + JSON.stringify(formData));
  let response = await doPostRequestImageFile(url, formData);
  log_info("Upload response: " + JSON.stringify(response));
  return response;
};

export const update_profile_document = async (
  userId,
  selectedFile,
  docName,
) => {
  const url =
    UPDATE_CLIENT_DOC +
    "?UserId=" +
    userId +
    "&ProfileDocsName=" +
    encodeURIComponent(docName); // 🔥 IMPORTANT

  const formData = new FormData();

  // 🔥 If wrapped object, extract real File
  formData.append("document", selectedFile.file ?? selectedFile);

  let response = await doPostRequestImageFile(url, formData);

  return response;
};

export const update_client_photo = async (userId, selectedFiles) => {
  const url = UPDATE_CLIENT_PHOTO + "?UserId=" + userId;
  const formData = await createFormDataForMultipleFiles("doc", selectedFiles);

  log_debug("formData: " + JSON.stringify(formData));
  let response = await doPostRequestImageFile(url, formData);
  log_info("Upload response: " + JSON.stringify(response));
  return response;
};
export const delete_client_photo = async (data) => {
  const url = DELETE_CLIENT_PHOTO;
  let response = await doPostRequest(url, data);
  return response;
};
export const delete_client_video = async (data) => {
  const url = DELETE_CLIENT_VIDEO;
  let response = await doPostRequest(url, data);
  return response;
};
export const set_main_profile_photo = async (data) => {
  const url = SET_MAIN_PROFILE_PHOTO;
  let response = await doPostRequest(url, data);
  return response;
};
export async function createFormData(fieldName, selectedFile) {
  const formData = new FormData();
  formData.append(fieldName, selectedFile); // selectedFile is a real File object
  return formData;
}

export async function createFormDataForMultipleFiles(fieldName, selectedFiles) {
  const formData = new FormData();
  selectedFiles.forEach((file) => {
    formData.append(fieldName, file); // real File object
  });
  return formData;
}

export async function createFormDataforVideo(fieldName, selectedFile) {
  const formData = new FormData();
  formData.append(fieldName, selectedFile); // real video File object
  return formData;
}

export const forward_to_client = async (matchData) => {
  let response = await doPostRequest(FORWARD_TO_CLIENT, {
    selectedClients: matchData,
  });
  return response;
};
export const create_matches_by_preference = async (data) => {
  let response = await doPostRequest(CREATE_MATCHES_BY_PREFERENCE, data);
  return response;
};

export const get_all_agents = async () => {
  console.log(GET_ALL_AGENTS);
  let response = await doGetRequest(GET_ALL_AGENTS);
  return response;
};

export const get_agent = async (UserId) => {
  let response = await doGetRequest(GET_AGENT + "?UserId=" + UserId);
  return response;
};
export const send_access_request = async (data) => {
  let response = await doPostRequest(SEND_REQUEST, data);
  return response;
};
export const delete_family_wealth = async (WealthId) => {
  let response = await doPostRequest(
    DELETE_FAMILY_WEALTH + "?WealthId=" + WealthId,
  );
  return response;
};

export const get_access_request = async (ProfileId, ToProfileId) => {
  let response = await doGetRequest(
    GET_REQUEST_STATUS +
      "?ProfileId=" +
      ProfileId +
      "&ToProfileId=" +
      ToProfileId,
  );
  return response;
};
export const check_access_request = async (ProfileId, ToProfileId) => {
  let response = await doGetRequest(
    CHECK_REQUEST_STATUS +
      "?ToProfileId=" +
      ProfileId +
      "&ProfileId=" +
      ToProfileId,
  );
  return response;
};

export const get_all_countries = async () => {
  let response = await doGetRequest(GET_ALL_COUNTRIES);
  return response;
};

export const get_states = async (countryId) => {
  console.log("countryId", GET_STATES + "?countryId=" + countryId);

  let response = await doGetRequest(GET_STATES + "?countryId=" + countryId);
  return response;
};

export const get_cities = async (countryId, stateId) => {
  console.log(
    "countryId",
    GET_CITIES + "?countryId=" + countryId + "&stateId=" + stateId,
  );

  let response = await doGetRequest(
    GET_CITIES + "?countryId=" + countryId + "&stateId=" + stateId,
  );
  return response;
};

export const get_notifications = async (AgentId) => {
  let response = await doGetRequest(GET_NOTIFICATIONS + "?AgentId=" + AgentId);
  return response;
};
export const get_notifications_for_profiles = async (ProfileId) => {
  let response = await doGetRequest(GET_NOTIFICATIONS_PROFILES + "?ToProfileId=" + ProfileId );
  return response;
};
export const get_commmunity_docs = async () => {
  let response = await doGetRequest(WEDLUK_COMMUNITY_DOCS);
  return response;
};

 

export const update_business_logo = async (userId, selectedFile) => {
  const extension = selectedFile.name.substring(
    selectedFile.name.lastIndexOf("."),
  );

  let cleanName = selectedFile.name
    .split(".")[0]
    .replace(/[^a-zA-Z0-9_-]/g, "")
    .trim();

  if (!cleanName) cleanName = "businessLogo";

  const newFileName = `${cleanName}${extension}`;

  const renamedFile = new File([selectedFile], newFileName, {
    type: selectedFile.type,
  });

  const formData = new FormData();

  formData.append("logo", renamedFile);

  const url = UPDATE_BUSINESS_LOGO + "?UserId=" + userId;

  return await doPostRequestImageFile(url, formData);
};

export const update_promotional_images = async (userId, selectedFiles) => {
  const formData = new FormData();

  for (const file of selectedFiles) {
    formData.append("promo", file);
  }

  const url = UPDATE_PROMOTIONAL_IMAGES + "?UserId=" + userId;

  return await doPostRequestImageFile(url, formData);
};

export const delete_promotional_image = async (data) =>{
    let response = await doPostRequest(DELETE_PROMOTIONAL_IMAGES, data);
  return response;
}

export const create_agent_review_from_profile = async (data) => {
  let response = await doPostRequest(CREATE_AGENT_REVIEW, data);
  return response;
};

export const get_agent_reviews = async (UserId) => {
  let response = await doGetRequest(GET_AGENT_REVIEW + "?UserId=" + UserId);
  return response;
};

export const get_agent_review_by_profile = async (UserId, ProfileId) => {
  let response = await doGetRequest(
    GET_AGENT_REVIEW_BY_PROFILE + `?UserId=${UserId}&ProfileId=${ProfileId}`,
  );

  return response;
};

export const disable_user_account = async (data) => {
  let response = await doPutRequest(DISABLE_USER_ACCOUNT, data);
  return response;
};
export const enable_user_account = async (data) => {
  let response = await doPutRequest(ENABLE_USER_ACCOUNT, data);
  return response;
};
export const delete_user_account = async (data) => {
  let response = await doPutRequest(DELETE_USER_ACCOUNT, data);
  return response;
};
export const report_issue = async (data) => {
  let response = await doPostRequest(REPORT_ISSUES, data);
  return response;
};
export const reset_password=async(data)=>{
  let response=await doPostRequest(RESET_PASSWORD,data)
  return response
}